import { DISPLAY_SNACKBAR, CLOSE_SNACKBAR } from "../constants/actionTypes";

const initialState = {
  display: false,
  message: "SAVE SUCCESSFUL",
  type: "info"
};

const userInteraction = (state = initialState, action) => {
  switch (action.type) {
    case DISPLAY_SNACKBAR:
      return {
        ...state,
        display: true,
        message: action.payload.message,
        type: action.payload.type
      };
    case CLOSE_SNACKBAR:
      return {
        ...state,
        display: false
      };
    default:
      return state;
  }
};

export default userInteraction;
